import styled from 'styled-components'
import { Recommendation } from '@/types/types'
import { CheckboxState } from './checkbox-state'

const Container = styled.div`
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 1px 9px 0 darkgray;
  border: solid 1px rgba(241, 242, 242, 0.28);
  background-color: white;
  margin: 10px 0;

  @media (max-width: 800px) {
    margin: 15px 0;
  }
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const TitleRow = styled.div<{ $complete: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  h5 {
    line-break: anywhere;
    margin: 0;
    font-weight: bold;
    ${({ $complete }) =>
      $complete
        ? `
      display: inline-block;
      position: relative;
      transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
      animation: fadeText 1.1s both;
      text-decoration: line-through;
    `
        : ''}
  }

  @keyframes fadeText {
    to {
      color: #bcbec0;
    }
  }
`

const Important = styled.div`
  &:hover {
    cursor: pointer;
  }

  @media (max-width: 800px) {
    padding: 0 10px 0 0;
  }
`

const Message = styled.p<{ $complete: boolean }>`
  ${({ $complete }) =>
    $complete
      ? `
    text-decoration: line-through;
    animation: fadeText 1.1s both;
  `
      : ''}
`

export interface RecommendationItemProps {
  rec: Recommendation
  mainColor?: string
}

export const RecommendationItem = ({ rec, mainColor }: RecommendationItemProps) => {
  const iconUrl = process.env.VUE_APP_ASSETS || ''

  return (
    <Container>
      <div>
        <Row className="side-by-side-flex">
          <TitleRow $complete={rec.completed}>
            <CheckboxState state={rec.completed} mainColor={mainColor} />
            <h5>{rec.displayName}</h5>
          </TitleRow>
          <Important
            title={rec.priority >= 20 ? 'This recommendation is important.' : undefined}
          >
            {rec.priority >= 20 && (
              <img
                src={`${iconUrl}/warning.svg`}
                width={16}
                height={16}
                alt="Warning"
              />
            )}
          </Important>
        </Row>
        <Message $complete={rec.completed}>
          {rec.description}
        </Message>
      </div>
    </Container>
  )
}
